export default "<div class=\"router-transitions\">\n  <router-outlet></router-outlet>\n</div>\n"